// eslint-disable-next-line import/prefer-default-export
export enum LoadingStatusEnum {
  loading, loaded,
}
